import { Modal } from "bootstrap";

export default class ConfirmationModal {
  constructor(node) {
    this.confirmationModalElement = node;
    this.initialize();
  }

  initialize() {
    this.confirmModal = new Modal(this.confirmationModalElement);
    this.keepChangesButton = this.confirmationModalElement.querySelector(".js-keep-changes");

    this.keepChangesButton.addEventListener("click", () => {
      this.confirmationModalElement.dispatchEvent(new Event("modal:keep-changes"));
    });
  }
}
